// TODO: It is important to type the below event for dataLayer
/*
  Below is the possible interfaces based on the analysis of the project

  interface CustomEventForAddCustomGaEvent {
    event: string;
    link_text?: string;
    return_type?: string;
    checkout_step_name?: string;
  }

  interface CustomEventForPushAnalyticsEvent {
    event: string;
    web_user_id: string;
    web_account_id: string;
    web_account_country: string;
  }

 */

export function useAnalytics() {
  function pushAnalyticsEvent(event: any) {
    window.dataLayer.push(event);
  }

  function addCustomGaEvent(event: any) {
    window.dataLayer.push(event);
  }

  return { pushAnalyticsEvent, addCustomGaEvent };
}
